import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import {
  create as addAttachment,
  deleteOne as deleteAttachment,
  getList as getListAttachment,
} from 'api/facilityHazarWasteAttachmentApi';
import { deleteOne, getOne } from 'api/facilityHazarWasteReportApi';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT, STYLE } from 'config';
import { DD_MM_YYYY } from 'constants/date';
import slug from 'constants/slug';
import { FIELDS as FACILITY_FIELDS } from 'containers/Coso/CosoView/ChiTietCosoPanel/constants';
import PageLockHOC from 'hoc/pageLock';
import { get } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import Message from 'rc-message';
import React from 'react';
import Permissions from 'react-redux-permissions';
import { Link, withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import { FIELDS } from '../constants';
import Attachment from './Attachment';
import { IS_ENTERPRISE } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

class RowValue extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isRequiredField: PropTypes.bool,
  };

  render() {
    return (
      <div>
        <Row>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Col
              style={this.props.isRequiredField ? STYLE.REQUIREDFIELD : {}}
              xs={2}
            >
              {this.props.label}
            </Col>
            <Col xs={7}>{this.props.value}</Col>
          </div>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

@PageLockHOC(['facilityHazarWasteReport.view'])
class FacilityHazarWasteReportView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  getInitialValue = (keyPath, defaultValue = '') => {
    let val = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!val) val = '';
    return val;
  };

  getInitialDateValue = (keyPath, isDate, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    if (isDate) return moment(value).format(DATE_FORMAT);
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOne(_id);
      if (res.success && res.data) {
        this.setState({
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.HAZARDOUS_WASTE_REPORT.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const FacilityNameFull = this.getInitialValue(
        'facility.FacilityNameFull'
      );

      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xóa báo cáo chất thải nguy hại của tên cơ sở/dự án: `}
            <b> {FacilityNameFull}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.HAZARDOUS_WASTE_REPORT.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  formatDate = (date) => {
    if (!date) return null;
    return moment(date).format(DD_MM_YYYY);
  };

  render() {
    const {
      match: {
        params: { _id },
      },
    } = this.props;

    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Báo cáo chất thải nguy hại
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Link to={slug.HAZARDOUS_WASTE_REPORT.LIST}>
              <Icon
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                icon={IconNames.CIRCLE_ARROW_LEFT}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
              />
            </Link>

            <Permissions allowed={[`facilityHazarWasteReport.write`]}>
              <React.Fragment>
                <Clearfix width={8} />
                <Link
                  to={
                    slug.HAZARDOUS_WASTE_REPORT.EDIT_WITH_ID +
                    this.state._idObject
                  }
                >
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.MANUALLY_ENTERED_DATA}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                  />
                </Link>
              </React.Fragment>
            </Permissions>

            <Permissions allowed={[`facilityHazarWasteReport.delete`]}>
              <React.Fragment>
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.BAN_CIRCLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={this.handelDelete}
                />
              </React.Fragment>
            </Permissions>
          </div>
        </HeaderContainer>
        <Clearfix height={16} />

        <React.Fragment>
          <RowValue
            isRequiredField
            label='Tên cơ sở/dự án'
            value={this.getInitialValue('facility.FacilityNameFull')}
          />
          {!IS_ENTERPRISE && (
            <RowValue
              label='Tên doanh nghiệp'
              value={this.getInitialValue('facility.organizationName')}
            />
          )}

          <RowValue
            label='Địa chỉ'
            value={this.getInitialValue('facility.Address1')}
          />

          <RowValue
            label='Mã số QLCTNH'
            value={this.getInitialValue(
              `facility.${FACILITY_FIELDS.reportHazardousWasteCode}`
            )}
          />
          <RowValue
            label='Ngày cấp'
            value={this.formatDate(
              this.getInitialValue(
                `facility.${FACILITY_FIELDS.reportHazardousWasteDate}`
              )
            )}
          />
          <RowValue
            label='Cấp lần'
            value={this.getInitialValue(
              `facility.${FACILITY_FIELDS.reportHazardousWasteAllocationTimes}`
            )}
          />
          <RowValue
            label='Ngày cấp lại'
            value={this.formatDate(
              this.getInitialValue(
                `facility.${FACILITY_FIELDS.reportHazardousWasteDateRenew}`
              )
            )}
          />
          <RowValue
            label='Hình thức xử lý'
            value={this.getInitialValue(
              `facility.${FACILITY_FIELDS.reportHazardousWasteFormProcessing}.Name`
            )}
          />
          <RowValue
            label='Khối lượng đăng ký'
            value={this.getInitialValue(
              `facility.${FACILITY_FIELDS.reportHazardousWasteMass}`
            )}
          />
          <RowValue
            label='Năm báo cáo'
            value={this.getInitialValue(FIELDS.NamBaoCao)}
          />
          <RowValue
            label='Hình thức nộp báo cáo'
            value={this.getInitialValue(FIELDS.HinhThucNop)}
          />
          <RowValue
            label='Ngày nộp báo cáo'
            value={this.formatDate(this.getInitialValue(FIELDS.NgayNopBaoCao))}
          />
          <RowValue
            label='Khối lượng phát sinh (kg)'
            value={this.getInitialValue(FIELDS.KhoiLuongPhatSinh)}
          />
          <RowValue
            label='Khối lượng chuyển giao (kg)'
            value={this.getInitialValue(FIELDS.KhoiLuongChuyenGiao)}
          />
          <RowValue
            label='Khối lượng tự xử lý (kg)'
            value={this.getInitialValue(FIELDS.KhoiLuongTuXuLy)}
          />
          <RowValue
            label='Khối lượng tồn lưu (kg)'
            value={this.getInitialValue(FIELDS.KhoiLuongTonLuu)}
          />
          <RowValue
            label='Phương pháp xử lý'
            value={this.getInitialValue(FIELDS.PhuongPhapXuLy)}
          />
          <RowValue
            label='Đơn vị thu gom'
            value={this.getInitialValue(FIELDS.DonViThuGom)}
          />
          <RowValue
            label='Thêm vào'
            value={
              this.getInitialDateValue('AddedOn') +
              ' bởi ' +
              this.getInitialValue('AddedBy')
            }
          />
          <RowValue
            label='Cập nhật lần cuối'
            value={
              this.getInitialDateValue('UpdatedOn') &&
              this.getInitialDateValue('UpdatedOn') +
                ' bởi ' +
                this.getInitialValue('UpdatedBy')
            }
          />
        </React.Fragment>
        <Clearfix height={16} />

        <Attachment
          moduleName={'facilityHazarWasteReport'}
          getListFunc={(query) => {
            return getListAttachment({
              ...query,
              wasteReport: _id,
            });
          }}
          createOne={(values) => {
            values.wasteReport = get(this.state.initialValue, '_id');
            return addAttachment(_.pickBy(values, _.identity));
          }}
          deleteOne={deleteAttachment}
          facility={this.state.facility}
        />
      </div>
    );
  }
}

export default withRouter(FacilityHazarWasteReportView);



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportView/index.js